/*
  Sticky Add to cart bar for product pages below 990px (audit D1).
  Mirrors the theme's own Add to cart button and clicks it, so variant,
  quantity, cart drawer and error handling stay with the theme.
*/
(function () {
  function init() {
    var realButton = document.querySelector('.product__info-container .product-form__submit[name="add"]');
    if (!realButton || document.querySelector('.tt-sticky-atc')) return;

    var titleEl = document.querySelector('.product__title h1, .product__title h2');
    var bar = document.createElement('div');
    bar.className = 'tt-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML =
      '<div class="tt-sticky-atc__info">' +
      '<span class="tt-sticky-atc__title"></span>' +
      '<span class="tt-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="button tt-sticky-atc__button"></button>';
    var barTitle = bar.querySelector('.tt-sticky-atc__title');
    var barPrice = bar.querySelector('.tt-sticky-atc__price');
    var barButton = bar.querySelector('.tt-sticky-atc__button');
    barTitle.textContent = titleEl ? titleEl.textContent.trim() : '';

    function currentPrice() {
      var price = document.querySelector('.product__info-container .price');
      if (!price) return '';
      var item = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--last')
        : price.querySelector('.price__regular .price-item--regular');
      return item ? item.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function sync() {
      var label = realButton.querySelector('span');
      barButton.textContent = (label ? label.textContent : realButton.textContent).trim();
      barButton.disabled = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
      barPrice.textContent = currentPrice();
    }

    barButton.addEventListener('click', function () {
      if (!barButton.disabled) realButton.click();
    });

    document.body.appendChild(bar);
    document.body.classList.add('tt-sticky-atc-page');
    sync();

    var infoContainer = document.querySelector('.product__info-container');
    if (infoContainer && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(infoContainer, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(realButton);
    } else {
      bar.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
